import Template from "./template.jsx";
import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import {service} from "../../../../../../lib/itn-ui-kit/services/service-container";

export default class FinanceCasesDetailExpenses extends BaseRoute {
  @service('repositories/additional-expense-repository') additionalExpenseRepository;

  element = <Template/>;

  async loader({params, request}) {
    const {id} = params;
    const url = new URL(request.url);
    const offset = parseInt(url.searchParams.get('offset') || '0');
    const limit = parseInt(url.searchParams.get('limit') || '10');

    const additionalExpenses = await this.additionalExpenseRepository.query({
      case: id,
      limit,
      offset
    });
    const additionalExpenseOptions = await this.additionalExpenseRepository.getOptions();
    const additionalExpenseCount = await this.additionalExpenseRepository.getTotalCount({case: id});

    return {
      additionalExpenses,
      additionalExpenseOptions,
      additionalExpenseCount
    };
  }
}
